import { Chip } from "@mui/material";
import { ClientInvoiceStatus, CLIENT_INVOICE_STATUS_LABELS } from "hvp-shared";

const statusColors: Record<ClientInvoiceStatus, "warning" | "info" | "success" | "error"> = {
  [ClientInvoiceStatus.pending]: "warning",
  [ClientInvoiceStatus.processing]: "info",
  [ClientInvoiceStatus.stamped]: "success",
  [ClientInvoiceStatus.failed]: "error",
  [ClientInvoiceStatus.requires_authorization]: "warning",
  [ClientInvoiceStatus.cancelled]: "info",
};

interface Props {
  status: ClientInvoiceStatus;
}

export const InvoiceStatusChip = ({ status }: Props) => {
  return (
    <Chip
      label={CLIENT_INVOICE_STATUS_LABELS[status] || status}
      color={statusColors[status] || "default"}
      size="small"
    />
  );
};
